import { render, staticRenderFns } from "./InterfaceTokens.vue?vue&type=template&id=d93ec9e2&scoped=true&"
import script from "./InterfaceTokens.vue?vue&type=script&lang=js&"
export * from "./InterfaceTokens.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceTokens.vue?vue&type=style&index=0&id=d93ec9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93ec9e2",
  null
  
)

export default component.exports